<template>
  <transition name="fade">
    <div
      class="login-warp"
      :class="[{ r1: shrinkPacket == 1 }, { r2: shrinkPacket == 2 }]"
      v-if="login"
    >
      <img class="login-bg" src="../assets/image/form-bg2.png" alt />
      <div class="login-form" v-if="this.$route.query.situs">
        <img class="bgimg" v-if="bgimg" :src="bgimg" />
        <img
          class="loginerweima"
          v-show="logintype"
          @click="changelogintype"
          src="../assets/image/banjieerweima.png"
        />
        <div
          :class="['login-form-container', { 'container-height': !bglogin }]"
        >
          <div class="login-form-title" v-if="logintype && !bgimg">
            账号登录
          </div>
          <div v-else></div>
          <div class="login-form-saoma" v-show="!logintype && !bgimg">
            扫码登录
          </div>
          <!-- <div v-show="logintype" class="divsaoma" @click="changelogintype">切换扫码登录</div> -->
          <!-- <div v-show="!logintype" class="divsaoma" @click="changelogintype">切换账号登录</div> -->
          <img
            v-show="!logintype"
            src="../assets/image/computer.png"
            class="divsaoma"
            @click="changelogintype"
          />
          <div v-show="logintype">
            <img
              class="login-zhanghao"
              src="../assets/image/zhanghao.png"
              alt
            />
            <img class="login-input" src="../assets/image/input1.png" alt />
            <input
              type="text"
              v-model="form.user"
              placeholder="请输入账号"
              ref="user"
            />
          </div>
          <div v-show="logintype">
            <img class="login-mima" src="../assets/image/mima.png" alt />
            <img class="login-input" src="../assets/image/input1.png" alt />
            <input
              type="password"
              v-model="form.pwd"
              placeholder="请输入密码"
              ref="pwd"
              @input="passwordReg"
              @keydown="focusPassword"
              @keydown.enter="confirm()"
            />
          </div>
          <p class="upper-case" v-if="upper">您已切换至大写</p>
          <p class="upper-case" v-else></p>
        </div>
        <div class="login-form-foot" v-show="logintype">
          <!-- <img class="login-button" src="../assets/image/button1.png" alt /> -->
          <div
            class="login-confirm"
            style="background: white"
            v-if="bglogin"
            @click="confirm"
          >
            <img class="bglogin" :src="bglogin" />
            <span>登录</span>
          </div>
          <div class="login-confirm" @click="confirm" v-else>
            <span>登录</span>
          </div>
        </div>

        <div class="erweima" v-show="!logintype">
          <div class="erweimabg" v-if="dosaoma"></div>
          <div class="erweimats" v-if="dosaoma">
            <img @click="clearsaoma" src="../assets/image/cxjzewm.png" />
            <br />扫码成功
          </div>
          <div class="qrcode" id="qrcode"></div>
        </div>
        <div class="shuomign" v-if="!logintype">请使用微信扫描上方二维码</div>
        <div class="backmsg" v-if="!logintype">{{ backmsg }}</div>
      </div>
      <div v-else class="login-errorform">
        未检测到登录站点
        <br />请您使用星云PMS登录器登录
      </div>
    </div>
  </transition>
</template>

<script>
import { getRequest, postRequest } from '@/api/api1.js'
import QRCode from '../assets/js/qrcode.js'
import global from './../Global.vue'

import axios from 'axios'
export default {
  data() {
    return {
      login: false,
      situs: '',
      form: {
        user: '',
        pwd: '',
      },
      listshow: [
        {
          tableName: 'TGuestInfo',
          fieldCode: 'accno',
          fieldName: '账号',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'guestname',
          fieldName: '姓名',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'mobilephone',
          fieldName: '电话号码',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'reservename',
          fieldName: '预定人',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'reservetel',
          fieldName: '预定人电话',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'sourceName',
          fieldName: '订单来源',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'roomname',
          fieldName: '房号',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'roomtypeid',
          fieldName: '房型',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'roomnum',
          fieldName: '房数',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'arrival',
          fieldName: '到店日期',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'arrtime',
          fieldName: '到店时间',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'departure',
          fieldName: '离店日期',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'deptime',
          fieldName: '离店时间',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'status',
          fieldName: '状态',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'custname',
          fieldName: '协议',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'numnights',
          fieldName: '天数',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'firstPrice',
          fieldName: '房价',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'rate',
          fieldName: '当日房价',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'totalroomprice',
          fieldName: '总房价',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'remarks',
          fieldName: '备注',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'secrecy',
          fieldName: '密',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'vip',
          fieldName: '贵',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'memaccno',
          fieldName: '会员',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'salesname',
          fieldName: '销售员',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'roomusetype',
          fieldName: '类型',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'operator',
          fieldName: '创建人',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'holdtime',
          fieldName: '保留时间',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'carcode',
          fieldName: '车牌号',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'fpfolio',
          fieldName: '发票号码',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'dingjin',
          fieldName: '定金',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'xiaofei',
          fieldName: '消费',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'yue',
          fieldName: '余额',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'fang',
          fieldName: '房',
          display: '1',
        },
        {
          tableName: 'TGuestInfo',
          fieldCode: 'xing',
          fieldName: '行',
          display: '1',
        },
      ],
      logintype: true,
      showerweima: true,
      isaddfalse: false,
      timer: null,
      getcount: 0,
      backmsg: ' ',
      dosaoma: false,
      canconfirm: true,
      upper: false,
      bgimg: '',
      bglogin: '',
      shrinkPacket: 0,
      timer1: null,
      dologin: true,
    }
  },
  created() {
    document.addEventListener('keydown', this.keyDown)
    if (this.$route.query.situs) {
      this.situs = this.$route.query.situs
      this.jdmc = this.$route.query.name
      this.jdlogo = this.$route.query.logo
      //console.log(3333, this.jdlogo)
      localStorage.setItem('situs', JSON.stringify(this.$route.query.situs))
      this.resources = this.$route.query.resources
      if (this.resources == 1) {
        getRequest('http://127.0.0.1:9009/readConfig').then(res => {
          // this.$parent.hotelName = "秒宿PMS";
          if (res.hotelname != null || res.hotelname != '') {
            this.$parent.hotelName = res.hotelname
          }
          if (res.company != null || res.company != '') {
            this.$parent.company = res.company
          }
          this.$parent.jdlogo = res.logo
          this.$parent.mobile = res.mobile
          this.$store.state.psmlogo = res.pmslogo
        })
      } else {
        if (this.jdmc != null && this.jdmc != '') {
          this.$parent.hotelName = this.$route.query.name
        }
        if (this.$route.query.logo != null && this.$route.query.logo != '') {
          this.$parent.jdlogo = global.api + this.$route.query.logo
        }
      }
    } else {
      this.$mymessage({
        content: '未检测到登录站点!',
        type: 'error',
        time: 3000,
        hasClose: false,
      })
    }

    this.getBg()
    setTimeout(() => {
      this.$refs.user.focus()
      // 集团跳转来的自动登录
      if (this.$route.query.from === 'jituan') {
        this.form.user = '0000'
        this.form.pwd = 'bwhis8888'
        this.confirm()
      }
    }, 100)
  },
  destroyed() {
    document.removeEventListener('keydown', this.keyDown)
  },
  mounted() {
    this.login = true
  },

  methods: {
    startRotate() {
      this.timer1 = setInterval(() => {
        //console.log(this.shrinkPacket)
        if (this.shrinkPacket == 0) {
          this.shrinkPacket = 1
        } else if (this.shrinkPacket == 1) {
          this.shrinkPacket = 2
        } else if (this.shrinkPacket == 2) {
          this.shrinkPacket = 1
        }
        //this.shrinkPacket = !this.shrinkPacket
      }, 50)

      setTimeout(() => {
        clearInterval(this.timer1)
        this.shrinkPacket = 0
        this.timer1 = null
      }, 1000)
    },

    keyDown(e) {
      if (e.keyCode == 13) {
        if (!this.form.user) {
          this.$mymessage({
            content: '请输入账号',
            type: 'error',
            time: 2000,
            hasClose: true,
          })
          this.$refs.user.focus()
          return
        } else {
          this.$refs.pwd.focus()
        }
      }
    },
    clearsaoma() {
      this.dosaoma = false
    },
    changelogintype() {
      this.logintype = !this.logintype
      if (!this.logintype && !this.isaddfalse) {
        this.qrcode()
      }
      if (!this.logintype) {
        this.dosaoma = false
        //扫码登记需要循环获取
        let that = this
        this.timer = setInterval(that.getLogin, 2000)
      } else {
        clearInterval(this.timer)
        this.getcount = 0
      }
    },
    getBg() {
      getRequest(
        '/bwSysFestival/selectByDate?date=' + this.dateMethod(new Date())
      ).then(res => {
        if (res.status == 200) {
          if (res.data && res.data.imgList) {
            let random = Math.random() * (res.data.imgList.length - 1)
            random = Math.round(random)

            this.bgimg = this.$store.state.api + res.data.imgList[random].bgimg
            this.bglogin =
              this.$store.state.api + res.data.imgList[random].bglogin
            this.leftimg =
              this.$store.state.api + res.data.imgList[random].leftimg
          }
        }
      })
    },
    getLogin() {
      //扫码登录
      this.getcount++
      getRequest('/getLoginInfoBySitus?situs=' + this.situs).then(res => {
        if (res.status == 0) {
          //继续轮训
          this.dosaoma = true
        } else if (res.status == 200) {
          //继续轮训
        } else if (res.status == 1) {
          //登录成功
          clearInterval(this.timer)
          this.setUser(res.data, res.serviceId)
        } else if (res.status == 2) {
          //选择账号
          this.backmsg = '请在手机端选择需要登录的账号'
          this.dosaoma = true
          this.logintype = true
        } else if (res.status == 3) {
          //没有绑定
          this.dosaoma = true
          clearInterval(this.timer)
          this.backmsg = '当前微信号未绑定账号'
          this.$mymessage({
            content: this.backmsg,
            type: 'error',
            time: 2000,
            hasClose: true,
          })
        } else {
          clearInterval(this.timer)
          this.$mymessage({
            content: res.message,
            type: 'error',
            time: 2000,
            hasClose: true,
          })
        }
      })
    },
    setUser(data, serviceId) {
      this.$store.state.isLogin = true
      // //重新排序
      var moduleList = data.moduleList
      this.sortByKey(moduleList, 'firstorder')
      moduleList = moduleList.reverse(moduleList)
      for (var i = 0; i < moduleList.length; i++) {
        var moduleList2 = this.sortByKey(moduleList[i].modules, 'secondorder')
        moduleList[i].modules = moduleList[i].modules.reverse(moduleList2)
      }
      //this.$store.commit('SetModules',data.moduleList);
      this.$store.commit('SetModules', moduleList)
      this.$store.state.ihotelid = data.ihotelid
      this.$store.state.cusercode = data.cusercode
      //this.$store.state.userinfo = data;
      localStorage.setItem('modules', JSON.stringify(moduleList))
      //localStorage.setItem('modules',JSON.stringify(data.moduleList));
      localStorage.setItem('power', JSON.stringify(data.rightList))
      localStorage.setItem('ihotelid', data.ihotelid)
      localStorage.setItem('cusercode', data.cusercode)
      localStorage.setItem('cphoto', data.cphoto)
      localStorage.setItem('cname', data.cname)
      localStorage.setItem('situs', this.situs)
      localStorage.setItem('iid', data.iid)
      localStorage.setItem('userInfo', JSON.stringify(data))
      this.$store.state.userInfo = data
      sessionStorage.setItem('token', serviceId)
      this.$cookie.set('token', serviceId, 1)
      this.$store.state.islogin = true

      getRequest(
        '/register/selectHotel?id=' + localStorage.getItem('ihotelid')
      ).then(res => {
        if (res.status == 200) {
          if (
            res.data.audiyn == 0 ||
            res.data.dhoteltime == null ||
            res.data.dhoteltime == ''
          ) {
            this.$mymessage({
              content: '请至后台配置夜审设置',
              type: 'error',
              time: 2000,
              hasClose: true,
            })
            return
          }

          this.$store.state.hotelInfo = res.data
          // let date = new Date('2021-01-14');
          let date = new Date()
          date = this.dateMethod(date)

          var date2 = new Date(res.data.dhoteltime)
          date2.setDate(date2.getDate() + 1)
          date2 = this.$moment(date2).format('YYYY-MM-DD')
          var time1 = new Date()
          var time2 = new Date(date2 + ' ' + res.data.auditimeauto)
          if (
            res.data.dhoteltime == date ||
            res.data.audiauto == 1 ||
            (res.data.audiauto == 0 && time1 < time2)
          ) {
            this.$router.replace('/jiazai')
          } else {
            this.$router.replace('/yesheng?iid=' + res.data.audiId)
          }
        } else {
          this.$mymessage({
            content: res.message,
            type: 'error',
            time: 2000,
            hasClose: true,
          })
        }
      })
      return

      // 酒店时间
    },

    dateMethod(date) {
      let year = date.getFullYear()
      let month =
        (parseInt(date.getMonth()) + 1).toString().length == 2
          ? parseInt(date.getMonth()) + 1
          : '0' + parseInt(date.getMonth() + 1).toString()
      let day =
        date.getDate().toString().length == 2
          ? date.getDate().toString()
          : '0' + date.getDate().toString()

      let time = year + '-' + month + '-' + day
      return time
    },
    passwordReg(e) {
      let reg = /[\u4e00-\u9fa5]/gi
      this.form.pwd = this.form.pwd.replace(reg, '')
      let reg2 = /^[A-Z]+$/
      let value = e.data

      if (reg2.test(value)) {
        this.upper = true
      } else {
        this.upper = false
      }
    },
    focusPassword(event) {
      var e = event || window.event
      var o = e.target || e.srcElement
      var oTip = o.nextSibling
      var keyCode = e.keyCode || e.which // 按键的keyCode;

      var isShift = e.shiftKey || keyCode == 16 || false // shift键是否按住
      if (
        (keyCode >= 65 && keyCode <= 90 && !isShift) || // Caps Lock 打开，且没有按住shift键
        (keyCode >= 97 && keyCode <= 122 && isShift) // Caps Lock 打开，且按住shift键
      ) {
        this.upper = true
      } else {
        this.upper = false
      }
    },
    qrcode() {
      if (this.$route.query.situs == null) {
        this.showerweima = false
        return
      }
      var url = global.yuming + 'phlogin'
      url += '?s=' + this.$route.query.situs
      let qrcode = new QRCode('qrcode', {
        width: 200,
        height: 200,
        text: url, // 二维码地址
      })
      qrcode._el.title = ''
      this.isaddfalse = true
    },
    confirm() {
      if (!this.dologin || this.timer1 != null) {
        return
      }
      if (!this.form.user) {
        this.$mymessage({
          content: '用户名不能为空',
          type: 'error',
          time: 3000,
          hasClose: true,
        })
        this.$refs.user.focus()
        return
      }
      if (!this.form.pwd) {
        this.$mymessage({
          content: '密码不能为空',
          type: 'error',
          time: 3000,
          hasClose: true,
        })
        this.$refs.pwd.focus()
        return
      }
      if (this.form.user.length > 20) {
        this.$mymessage({
          content: '用户名不允许超过20位',
          type: 'error',
          time: 3000,
          hasClose: true,
        })
        this.$refs.user.focus()
        return
      }
      if (this.form.pwd.length > 20) {
        this.$mymessage({
          content: '密码不允许超过20位',
          type: 'error',
          time: 3000,
          hasClose: true,
        })
        this.$refs.user.pwd()
        return
      }
      if (!this.canconfirm) {
        return
      }
      this.canconfirm = false
      let loadingInstance = this.$loading({
        text: '登录中',
      })
      this.dologin = false
      postRequest('/userlogin', {
        cusercode: this.form.user,
        cpassword: this.form.pwd,
        situs: this.situs,
      }).then(res => {
        this.$nextTick(() => {
          loadingInstance.close()
        })
        if (res.status == 200) {
          this.setUser(res.data, res.serviceId)

          //重新排序
          // var moduleList = res.data.moduleList;
          // this.sortByKey(moduleList,'firstorder')
          // moduleList = moduleList.reverse(moduleList);
          // for(var i = 0;i<moduleList.length;i++){
          //   var moduleList2 = this.sortByKey(moduleList[i].modules,'secondorder');
          //   moduleList[i].modules = moduleList[i].modules.reverse(moduleList2);
          // }
          // //this.$store.commit('SetModules',res.data.moduleList);
          // this.$store.commit('SetModules',moduleList);
          // this.$store.state.ihotelid = res.data.ihotelid;
          // this.$store.state.cusercode = res.data.cusercode;
          // //this.$store.state.userinfo = res.data;
          // localStorage.setItem('modules',JSON.stringify(moduleList));
          // //localStorage.setItem('modules',JSON.stringify(res.data.moduleList));
          // localStorage.setItem("power", JSON.stringify(res.data.rightList));
          // localStorage.setItem('ihotelid',res.data.ihotelid);
          // localStorage.setItem('cusercode',res.data.cusercode);
          // localStorage.setItem('cphoto',res.data.cphoto);
          // localStorage.setItem('cname',res.data.cname);
          // localStorage.setItem('situs', this.situs);
          // sessionStorage.setItem("token", res.serviceId);
          // this.$store.state.islogin = true
          // this.$router.replace("/jiazai");
          this.getGusetTitle()
        } else {
          this.canconfirm = true
          this.dologin = true
          this.startRotate()
          this.$mymessage({
            content: res.message,
            type: 'error',
            time: 2000,
            hasClose: true,
          })
        }
      })
    },
    getGusetTitle() {
      let parms = {
        tableName: 'TGuestInfo',
      }
      postRequest('/tFieldDisplay/selectTFieldDisplay', parms).then(res => {
        // this.$nextTick(() => {
        //   loadingInstance.close();
        // });
        if (res.status == 200) {
          if (res.data.length > 0) {
            this.$store.state.listshow = res.data
          } else {
            this.$store.state.listshow = this.listshow
          }
        } else {
          this.$mymessage({
            content: res.message,
            type: 'error',
            time: 2000,
            hasClose: true,
          })
        }
      })
    },
    sortByKey(array, key) {
      return array.sort(function(a, b) {
        var x = a[key]
        var y = b[key]
        return x > y ? -1 : x < y ? 1 : 0
      })
    },
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
}
.fade-enter {
  transform: translateX(100%);
}
.login-warp {
  position: relative;
  width: 100%;
  height: 82%;
}
.login-bg {
  width: 100%;
  height: 100%;
  background: #e7f0ff;
  opacity: 0.5;
}
.login-form {
  position: absolute;
  top: 8%;
  left: 8%;
  width: 84%;
  height: 84%;
}
.login-form .bgimg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.login-form-title {
  color: #2562a5;
  font-size: 1.75em;
  display: flex;
  align-items: center;
}
.login-form-container {
  height: 64%;
  margin: 0 10%;
  display: flex;
  flex-direction: column;
}
.login-form-container div {
  flex: 1;
  position: relative;
}
.login-form-container input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 70% !important;
  padding-left: 20%;
  outline: none;
  font-size: 16px;
  color: #6d798e;
}
.login-zhanghao {
  position: absolute;
  left: 5%;
  width: 1.8em;
  z-index: 9;
  top: 14%;
}

.login-mima {
  position: absolute;
  left: 5%;
  width: 1.6em;
  z-index: 9;
  top: 15%;
}
.login-input {
  width: 100%;
  height: 70%;
  color: #6d798e;
  font-size: 1.3em;
}
.login-form-foot {
  height: 33%;
  position: relative;
  top: -5%;
}
.login-form-foot:hover {
  transform: scale(1.1);
}
.login-button {
  width: 100%;
  height: 100%;
}
.login-confirm {
  position: absolute;
  top: 28%;
  left: 9.5%;
  width: 81%;
  font-size: 1.7em;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: #1471fe;
  color: #fff !important;
  height: 45%;
  border-radius: 0.2em;
}
.login-confirm .bglogin {
  position: absolute;
  top: -63%;
  left: -11.5%;
  width: 123%;
  height: 226%;
}
.login-confirm span {
  z-index: 99;
}
.login-form-container p {
  height: 16px;
  margin-top: -20px;
}
.login-errorform {
  position: absolute;
  top: 40%;
  left: 10%;
  width: 80%;
  text-align: center;
  color: red;
  line-height: 3em;
}
.login-button:hover {
  transform: scale(1.1);
}

.divsaoma {
  position: absolute !important;
  right: 11%;
  top: 5%;
  color: #2562a5;
  cursor: pointer;
  width: 60px;
}
.divsaoma:hover {
  transform: scale(1.1);
}
.erweima {
  padding: 10px;
  position: absolute;
  top: 25%;
  left: 0px;
  right: 0px;
  width: 200px;
  height: 200px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
.erweimabg {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9;
  background: #000000;
  opacity: 0.5;
  filter: alpha(opacity=50);
}
.erweimats {
  position: absolute;
  width: 100%;
  height: 2rem;
  z-index: 99;
  color: #fff;
  font-weight: bold;
  font-size: 1.4rem;
  top: 25%;
  cursor: pointer;
}
.erweimats img {
  width: 50px;
  margin-bottom: 10%;
}
.erweimats img:hover {
  transform: scale(1.1);
}

.shuomign {
  margin-top: 3rem;
  font-size: 1em;
  position: absolute;
  bottom: 5%;
  text-align: center;
  width: 100%;
}
.login-form-saoma {
  color: rgb(37, 98, 165);
  font-size: 1.75em;
  align-items: center;
  top: 10%;
}
.backmsg {
  color: red;
  line-height: 3em;
  font-size: 1.2em;
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
}
.loginerweima {
  width: 60px;
  position: absolute;
  cursor: pointer;
  top: 5%;
  right: 11%;
  z-index: 99;
}
.upper-case {
  font-size: 12px;
  color: red;
  height: 12px;
  margin-top: -8px;
}
.container-height {
  height: 67%;
}

.r1 {
  transform: rotate(-2deg);
}
.r2 {
  transform: rotate(2deg);
}
</style>
